"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _loadersAndSpinners = require("@kyruus/loaders-and-spinners");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
const NextLoader = () => /*#__PURE__*/_react.default.createElement(_styles.LoadingContainer, null, /*#__PURE__*/_react.default.createElement(_loadersAndSpinners.FadingLinesSpinner, null), /*#__PURE__*/_react.default.createElement(_styles.Msg, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.nextloader)));
NextLoader.propTypes = {
  msg: _propTypes.string.isRequired
};
var _default = exports.default = NextLoader;
NextLoader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NextLoader",
  "props": {
    "msg": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};